import { render, staticRenderFns } from "./BankMovements.vue?vue&type=template&id=4f009e48"
import script from "./BankMovements.vue?vue&type=script&lang=js"
export * from "./BankMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports